<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--container">
    <div class="flex--row flock-container">
      <div class="spacing--margin-right" *ngIf="(flocks$ | async)?.length > 0">
        <mat-form-field class="flex__child--auto item-selector">
          <mat-label>{{ 'flock-overview.placeholder' | translate }}</mat-label>
          <mat-select
            formControlName="flock"
            [hideSingleSelectionIndicator]="true"
            placeholder="{{ 'flock-overview.placeholder' | translate }}"
            data-test="flock-overview__flock-selector1"
          >
            <mat-option [value]="null">{{ 'flock-overview.unassigned' | translate }}</mat-option>
            <mat-option *ngFor="let flock of flocks$ | async" [value]="flock">
              {{ flock.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
</agr-form-dialog>
